import type { UserRole } from '@/common/user.common'
import { ROLES, type Role } from '@/constants/roles.constants'

export type NormalizedRole = Role // 'admin' | 'user' | 'manager'

export function normalizeRole(raw: unknown): UserRole {
  const r = typeof raw === 'string' ? raw.toLowerCase() : ''

  if (r.includes('admin')) return ROLES.ADMIN
  if (r.includes('manager')) return ROLES.MANAGER
  if (r.includes('user')) return ROLES.USER

  // backend still sends "offline_access", "profile", "openid"
  return ROLES.USER
}
